export default "__VITE_ASSET__BtzHmiFp__"